/**
 * Index
 *
 * フロントで使用する JS をまとめて読み込む
 */

import './scss/main.scss';
import 'slick-carousel';
import Packery from 'packery';
import * as modules from "./modules";

// コンポーネント
modules.diagnosis('js-diagnosis');
modules.fixedNavi('js-fixed-navi', 'toc_container');
modules.rankingFilters('ranking-pickup', 'js-ranking-filter', 'js-ranking-fixed');
modules.sliderCalc();
modules.tabSwitch('js-tab-switch');
modules.toggleBlock('js-toggle');

// ユーティリティ関数
modules.alignCenter('js-supervisor-slider');
modules.draggable('.js-draggable');
modules.rateStar();
modules.toggleCurrentNavItem();
modules.toggleModal('data-modal');
modules.smoothScroll();


window.addEventListener('DOMContentLoaded', function () {
	/** ナビゲーション */
	var menuButtons = document.getElementsByClassName('js-menu');
	var searchButtons = document.getElementsByClassName('js-search');
	var searchInput = document.getElementById('js-search-input');
	var closeButtons = document.getElementsByClassName('js-close');
	var body_element = document.querySelector('html body');

	if (menuButtons.length) {
		for (let i = 0; i < menuButtons.length; i++) {
			menuButtons[i].onclick = function () {
				body_element.classList.toggle('js-menu-active');
			}
		}
	}

	if (searchButtons.length) {
		for (let i = 0; i < searchButtons.length; i++) {
			searchButtons[i].onclick = function () {
				body_element.classList.add('js-search-active');
				searchInput.focus();
			}
		}
	}

	if (closeButtons.length) {
		for (let i = 0; i < closeButtons.length; i++) {
			closeButtons[i].onclick = function () {
				body_element.classList.remove('js-search-active');
				body_element.classList.remove('js-menu-active');
			}
		}
	}

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') {
			body_element.classList.remove('js-search-active');
			body_element.classList.remove('js-menu-active');
		}
	})
});

// クラス名「active」をトグル
document.addEventListener('DOMContentLoaded', function () {
	const buttons = document.querySelectorAll('[data-switch-active]');
	if (buttons.length > 0) {
		buttons.forEach(button => {
			button.addEventListener('click', function () {
				// data-switch-active 属性の値を取得
				const targetId = button.getAttribute('data-switch-active');

				// 属性値が空でないことを確認
				if (targetId) {
					const targetElement = document.getElementById(targetId);

					// 対象の要素が存在する場合、クラス 'active' をトグル
					if (targetElement) {
						targetElement.classList.toggle('active');
					}
				}
			});
		});
	}
});

window.addEventListener('load', function () {
	const icon = document.getElementById('js-chat-wrap');
	if (icon) {
		icon.classList.add('active');
	}
});

// スライダー
jQuery(function ($) {
	$("#js-slick").slick({
		infinite: true,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 1000,
		arrows: false,
		dots: true,
		dotsClass: 'p-slider__dots',
		centerMode: true,
		variableWidth: true,
	});

	$('.p-slider__dots').prepend(function () {
		return '<li class="p-slider__arrow p-slider__prev"></li>';
	});

	$('.p-slider__dots').append(function () {
		return '<li class="p-slider__arrow p-slider__next"></li>';
	});

	$('.p-slider__prev').on('click', function () {
		$('#js-slick').slick('slickPrev');
	});

	$('.p-slider__next').on('click', function () {
		$('#js-slick').slick('slickNext');
	});

	$("#js-pickup").slick({
		infinite: true,
		autoplay: true,
		autoplaySpeed: 3000,
		speed: 1000,
		arrows: false,
		dots: true,
		dotsClass: 'p-slider__dots',
		centerMode: true,
		variableWidth: true,
	});
});


var grid = document.querySelector('.js-grid');
var packery;

function initPackery() {
	if (packery) packery.destroy();

	packery = new Packery(grid, {
		itemSelector: '.js-grid__item',
		gutter: window.innerWidth < 768 ? 24 : 40,
	});
}

// 初回
initPackery();

// リサイズ対応（リサイズ完了後に実行）
let resizeTimer;
window.addEventListener('resize', function () {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(initPackery, 250); // debounce
});

import ScrollHint from 'scroll-hint';

const scrollHintOptions = {
	scrollHintIconAppendClass: 'scroll-hint-icon-white',
	i18n: {
		scrollable: 'スクロールできます'
	}
};

const selectors = [
	'.p-sticky-table',
	'.p-sticky-table--ranking',
	'.p-rankingWrap',
	'.js-draggable'
];

selectors.forEach(selector => {
	new ScrollHint(selector, scrollHintOptions);
});
